<div class="formContainer">

    <div class="form-header-background">
      <div class="form-title-parent-div">
        <h1 class="form-title">
          340B Entity Verification Form
        </h1>
      </div>
      <div class="form-close-parent-div">
        <fa-icon class="glyphicon glyphicon-question-sign cur-pntr" (click)="close()"
        style="font-size: 30px;" [icon]="faTimes"></fa-icon>
      </div>
    </div>
  
  
    <div class="form-intro" >
      <div class="div-container" >
        <fa-icon [icon]="faCheck" style="padding-top: 3px;"></fa-icon>
        <div>
          <span class="form-email-first">Form Submitted successfully to {{wo340BEmailInquires}}</span> <br/> 
          <span class="form-email-second">Acknowledgment email sent to {{adminEmail}} and {{loggedInUserEmailId}}</span>
        </div>
      </div>  
    </div>
    <form name="form" #f="ngForm" novalidate>
      <div class="form-body">
          <h4 class="heading-weight"> Print the submitted 340B form for your reference</h4>
          <div class="div-container">          
            <span class="span-pdf-icon"><fa-icon [icon]="faFilePdf"class="pdf-icon"></fa-icon> 340B Entity Verification Form {{customerShipToNum}}</span>
            <div><button class="button-cancel" (click)="submit(f,'print')">Print</button></div>
            
          </div>
          <h4 class="heading-weight"> Email the submitted 340B form to the following email addresses:</h4>

            <div class="div-container">
                <div style="width: 40%;">
                  <input type="text" 
                  class="form-control additional-email" 
                  name="email"
                  [(ngModel)]="additionalEmails"
                  required
                  #email="ngModel"                 
                  [ngClass]="{ 'is-invalid': submitted && email.errors }"
                  pattern="(([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\s*(,)\s*|\s*$))*">
                
                  <div><span style="color: #aaa;">(email1,email2,email3...)</span></div>
                  <div *ngIf="submitted && email.errors" class="invalid-feedback">
                    <div *ngIf="email.errors['required']">Email is required</div>
                    <div *ngIf="email.errors['pattern']">Email is invalid</div>
                  </div>
                </div>                
                <div><button type="submit" class="button-cancel cancel-padding" (click)="submit(f,'email')">Send Email</button></div>
            </div>
      </div>
    </form>
      <button
      type="submit"
      name="button"
      class="button-submit"
      (click)="close()"
      >
      Close
      </button>
      
  </div>
  

<div style="height: 0 !important;overflow: scroll;">
  <entity-verification-pdf [entityFormData]="formData" [pdfType]="pdfType"></entity-verification-pdf> 
</div>
  
  
